import { createContext, useContext } from 'react';

import type { AppContextValue } from 'app/App';

export const AppContext = createContext({} as AppContextValue);
AppContext.displayName = 'AppContext';

export const useApp = () => useContext(AppContext);